import type { JSX } from 'react';

import { Container } from '@change-corgi/design-system-legacy/layout';

import { PageBanner } from '../components/PageBanner';
import { PageBody } from '../components/PageBody';
import { PageFooter } from '../components/PageFooter';
import { PageHeading } from '../components/PageHeading';
import { PageMeta } from '../components/PageMeta';

import { useTrackPageView } from './hooks/useTrackPageView';

export function Layout(): JSX.Element {
	useTrackPageView();

	return (
		<>
			<PageMeta />
			<PageBanner />
			<Container mt={16} pb={16}>
				<PageHeading />
				<PageBody />
			</Container>
			<PageFooter />
		</>
	);
}
